/**
 * Persistent house-ad slot in the classic cabinet's control-panel footer
 * (sc-6959). Mirror of the remaster's cabinet-ad — same bundled 728x90
 * creatives (copied into this app's public/ads/), 15s rotation, no reveal
 * delay. Skips the swap while a cartridge is playing (the footer is hidden
 * via body[data-cabinet-mode='playing']).
 */

import { recordAdEvent } from '../api/client.js';
import { getOrCreateDeviceId } from './identity.js';

interface HouseAd {
  id: string;
  img: string;
  href: string;
  alt: string;
}

const HOUSE_ADS: readonly HouseAd[] = [
  { id: 'parkpursuit', img: '/ads/parkpursuit-728x90.png', href: 'https://parkpursuit.app', alt: 'ParkPursuit — Walk. Ride. Win.' },
  { id: 'zyphr', img: '/ads/zyphr-728x90.png', href: 'https://zyphr.dev', alt: 'zyphr.dev — transactional messaging API' },
  { id: 'privateerprofits', img: '/ads/privateerprofits-728x90.png', href: 'https://bigegogames.com/games/privateerprofits', alt: 'Privateer Profits — rule the trade winds' },
  { id: 'bigegogames', img: '/ads/bigegogames-728x90.png', href: 'https://bigegogames.com', alt: 'Big Ego Games — games with an attitude' },
  { id: 'arcraz', img: '/ads/arcraz-728x90.png', href: 'https://arcraz.com', alt: 'Arcraz — Code. Craft. Deliver.' },
];

const ROTATE_MS = 15_000;

function pick(exclude: string): HouseAd {
  const pool = HOUSE_ADS.filter((a) => a.id !== exclude);
  const from = pool.length > 0 ? pool : HOUSE_ADS;
  return from[Math.floor(Math.random() * from.length)]!;
}

export function mountCabinetAd(): void {
  const host = document.getElementById('cabinet-ad');
  if (!(host instanceof HTMLElement) || host.dataset.mounted === '1') return;
  host.dataset.mounted = '1';

  const link = document.createElement('a');
  link.className = 'control-panel__ad-link';
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.setAttribute('aria-label', 'Sponsor message');
  const img = document.createElement('img');
  img.width = 728;
  img.height = 90;
  img.decoding = 'async';
  img.loading = 'lazy';
  link.appendChild(img);
  host.appendChild(link);

  let current = '';
  link.addEventListener('click', () => {
    if (current) recordAdEvent({ slot: 'cabinet-footer', adId: current, event: 'click', deviceId: getOrCreateDeviceId() });
  });

  const show = (): void => {
    const ad = pick(current);
    current = ad.id;
    img.src = ad.img;
    img.alt = ad.alt;
    link.href = ad.href;
    link.dataset.adId = ad.id;
    link.classList.remove('is-fading');
    void link.offsetWidth;
    link.classList.add('is-visible');
    recordAdEvent({ slot: 'cabinet-footer', adId: ad.id, event: 'impression', deviceId: getOrCreateDeviceId() });
  };

  show();
  window.setInterval(() => {
    if (document.body.dataset.cabinetMode === 'playing') return;
    link.classList.add('is-fading');
    window.setTimeout(show, 220);
  }, ROTATE_MS);
}
